/*-----------------------------------------------------------------
- Marketplace
-----------------------------------------------------------------*/

export default {
    title             : 'Marketplace',
    'case-study-title': 'Real Success Stories with Quarkino',
};
